import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { useWeb3Modal } from '@web3modal/ethers/react';
import { useWeb3ModalAccount } from '@web3modal/ethers/react';
import { Link } from "react-router-dom";



const Navbar = ({ vContract }) => {
  // We'll update this state based on scroll position
  const [activePage, setActivePage] = useState('presale');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(prev => !prev);

  const { open } = useWeb3Modal();
  const { address, isConnected } = useWeb3ModalAccount();
  const [isOwner, setIsOwner] = useState(false);

  useEffect(() =>{
    if(isConnected) {
      getData();
    }
  },[vContract])

  const getData = async() => {
    try {
      const owner = await vContract.owner();
        if(owner === address) {
          setIsOwner(true);
        }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      // List the ids of your sections in the order they appear on the page
      const sections = ['presale', 'claim', 'stake'];
      let currentSection = sections[0];

      sections.forEach((section) => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          // If the section's top is above the center of the viewport, we consider it "active"
          if (rect.top <= window.innerHeight / 2) {
            currentSection = section;
          }
        }
      });

      setActivePage(currentSection);
    };

    window.addEventListener('scroll', handleScroll);
    // Trigger it once on mount in case the user is not at the top
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <nav className="navbar">
        {/* Burger menu on mobile (left side) */}
        <div className="burger" onClick={toggleSidebar}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>

        {/* Project name */}
        <div className="navbar__center">
          <h1 className="project-name">THEME TECHNOLOGY</h1>
        </div>

        {/* Admin Panel Button */}
        {isOwner ? (
          <Link to="/admin">
            <button className="buy-button">Admin Panel</button>
          </Link>
        ) : null}

        <button className="buy-button" onClick={() => open()}>{isConnected && address ? address.slice(0,4) + "..." + address.slice(38,42) : "Connect Wallet"}</button>

        {/* Desktop navigation links */}
        {!isOwner ? (
          <div className="navbar__right">
          <ul className="nav-links">
            <li>
              <a 
                href="#presale" 
                className={`nav-link ${activePage === 'presale' ? 'active' : ''}`}
              >
                Buy
              </a>
            </li>
            <li>
              <a 
                href="#claim" 
                className={`nav-link ${activePage === 'claim' ? 'active' : ''}`}
              >
                Claim
              </a>
            </li>
            <li>
              <a 
                href="#stake" 
                className={`nav-link ${activePage === 'stake' ? 'active' : ''}`}
              >
                Stake
              </a>
            </li>
          </ul>
        </div>
        ) : null}
      </nav>

      {/* Sidebar for mobile navigation */}
      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="close-btn" onClick={toggleSidebar}>&times;</div>
        <ul className="sidebar-links">
          <li>
            <a 
              href="#presale" 
              className={`sidebar-link ${activePage === 'presale' ? 'active' : ''}`}
              onClick={toggleSidebar}
            >
              Presale
            </a>
          </li>
          <li>
            <a 
              href="#claim" 
              className={`sidebar-link ${activePage === 'claim' ? 'active' : ''}`}
              onClick={toggleSidebar}
            >
              Claim
            </a>
          </li>
          <li>
            <a 
              href="#stake" 
              className={`sidebar-link ${activePage === 'stake' ? 'active' : ''}`}
              onClick={toggleSidebar}
            >
              Stake
            </a>
          </li>
        </ul>
      </aside>
    </>
  );
};

export default Navbar;
